import "./ahref.scss";

interface IAHref {
    children: React.ReactNode;
    href: string;
    target?: React.HTMLAttributeAnchorTarget,
    download?: string | boolean,
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void,
}

const AHref: React.FC<IAHref> = ({ children, href, target = "_self", download, onClick }) => {
    return (
        <> {href ?
            <a
                className="ahref"
                href={href}
                target={target}
                download={download ? download : false}
                onClick={onClick}
            >
                {children}
            </a> :
            <span className="ahref">
                {children}
            </span>
        }
        </>
    );
}

export default AHref;
